import { render, staticRenderFns } from "./CountdownWebinar.vue?vue&type=template&id=28ad5380&"
import script from "./CountdownWebinar.vue?vue&type=script&lang=js&"
export * from "./CountdownWebinar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports